<div class="tab-divider"></div>

@if(data?.view === 'uploadTestCaseDoc') {
<div class="row top-div">
  <div class="div-container" *ngFor="let data of sectionData">
    <div class="section-header">
      <div class="number-circle">{{ data.id }}</div>
      <span class="section-title">{{ data.title }}</span>
    </div>

    <div class="dropdown-container" *ngIf="data.dropDownOptions">
      <div class="row">
        <span class="data-label"
          >{{ data.dropDownLabel }}
          <i
            class="bi bi-info-circle"
            title="Information"
            *ngIf="data.infoUrl"
          ></i>
        </span>
      </div>
      <select
        class="dropdown-select"
        [(ngModel)]="data.selectedOption"
        (change)="onDropdownChange($event,data )"
      >
        <option *ngFor="let option of data.dropDownOptions" [value]="option">
          {{ option }}
        </option>
      </select>
    </div>

    <app-file-upload
      [data]="data?.uploadFile ? data.uploadFile : {}"
      (filesSelected)="handleFilesSelected($event, data)"
      class="col-md-12"
    ></app-file-upload>
  </div>
</div>
} @else if(data?.view === 'userStoriesOverview') {
<div class="table-wrapper h-100 mt-2">
  <ng-container *ngIf="data?.tableData?.data?.length; else noDataTemplate">
    <div class="table-title d-flex flex-column justify-content-center ps-3">
      <span class="header-5">{{ data?.tableData?.tableHeader }}</span>
    </div>
    <app-table-view
      class="w-100"
      [columns]="data?.tableData?.columns"
      [data]="data?.tableData?.data"
    ></app-table-view>
  </ng-container>

  <ng-template #noDataTemplate>
    <app-no-data></app-no-data>
  </ng-template>
</div>
} @else if(data?.view === 'testReview') { } @else if(data?.view === 'dashboard')
{ }
